import { useState, useEffect } from 'react';
import './Loader.css';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const loaderGif = require('../../assets/loading/loader.gif');

const LOADING_MESSAGES = [
  'Extracting list of sites based on the filters',
  'Calculating account penetration',
  'Finding solution recommendation',
  'Aggregating results',
  'Presenting results'
];

export default function Loader() {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [dotCount, setDotCount] = useState(1);

  useEffect(() => {
    const currentMessage = LOADING_MESSAGES[currentMessageIndex];
    let charIndex = 0;

    const typeInterval = setInterval(() => {
      if (charIndex < currentMessage.length) {
        setDisplayedText(currentMessage.substring(0, charIndex + 1));
        charIndex++;
      } else {
        clearInterval(typeInterval);
        setTimeout(() => {
          setCurrentMessageIndex((prev) => (prev + 1) % LOADING_MESSAGES.length);
          setDisplayedText('');
          setDotCount(1);
        }, 800);
      }
    }, 50);

    return () => clearInterval(typeInterval);
  }, [currentMessageIndex]);

  useEffect(() => {
    const dotInterval = setInterval(() => {
      setDotCount((prev) => (prev % 3) + 1);
    }, 300);

    return () => clearInterval(dotInterval);
  }, []);

  return (
    <div className="loader-container">
      <div className="loader-content">
        <img
          className="loader-video"
          src={loaderGif}
          alt="Loading"
        />
        <p className="loader-message">
          {displayedText}
          <span className="loader-dots">
            {'.'.repeat(dotCount)}
          </span>
        </p>
      </div>
    </div>
  );
}
